export default {
  mapsKey: "AIzaSyAMJENJ4OntnUaUDlLX0yWSjIlulQO-_kw",
};
